export const useHelpers = () => {
    
    const getCurrentDate = () => {
        const today = new Date(); // Crea un objeto de fecha con la fecha actual
        const year = today.getFullYear(); // Obtiene el año
        const month = today.getMonth() + 1; // Obtiene el mes (getMonth() devuelve un índice basado en cero, por lo que se suma 1)
        const day = today.getDate(); // Obtiene el día del mes
    
        // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
        return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    }

    const identifySelectedRequestType = (arraySubtypes, dataToSearch) => {
        const foundValue = arraySubtypes.find(item => item.idgestiontipo === dataToSearch)

        return (foundValue)? foundValue.prefijo : 'No se ha seleccionado nada'
    }

    const getGeneralBody = ({user, FormRequestGlobal, isForUpdate}) => {
           
        const currentDate = getCurrentDate()

        return {
            idgestion : FormRequestGlobal.formState.idgestion,
            idgestiontipo : FormRequestGlobal.formState.idgestiontipo,
            idcontrato : FormRequestGlobal.formState.idcontrato,
            aprobacion_check : FormRequestGlobal.formState.aprobacion_check, 
            aprobacion_usuario: user.username, 
            aprobacion_fecha: currentDate
        }
        
    }

    const getBodyForDateChange = ({user, FormRequestGlobal, isForUpdate}) => {
           
        const currentDate = getCurrentDate()

        const usuarioField = isForUpdate ? 'usuario_modifico' : 'usuario_creo';
        const fechaField = isForUpdate ? 'fecha_modifico' : 'fecha_creo';

        return {
            // // datos globales
            idcontrato: FormRequestGlobal.formState.idcontrato,
            idgestiontipo: FormRequestGlobal.formState.idgestiontipo,
            gestion_fecha: currentDate,
            gestion_usuario: user.username,
            gestion_descripcion: FormRequestGlobal.formState.gestion_descripcion,
            gestion_nuevo_dia_pago: FormRequestGlobal.formState.gestion_nuevo_dia_pago,
            aprobacion_check: FormRequestGlobal.formState.aprobacion_check,
            aprobacion_fecha : currentDate,
            [usuarioField]: user.username,
            [fechaField]: currentDate,
        }
        
    }

    const getBodyForPaymentExemptions = ({user, FormRequestGlobal, isForUpdate}) => {
           
        const currentDate = getCurrentDate()

        return {
            idgestion : FormRequestGlobal.formState.idgestion,
            idgestiontipo : FormRequestGlobal.formState.idgestiontipo,
            idcontrato : FormRequestGlobal.formState.idcontrato,
            aprobacion_check : FormRequestGlobal.formState.aprobacion_check, 
            aprobacion_usuario: user.username, 
            aprobacion_fecha: currentDate,
            paymentExemptionDetails: FormRequestGlobal.formState.paymentExemptionDetails.map((item) => ({
                idpago: parseInt(item.idpago, 10),
                idcontrato: parseInt(item.idcontrato, 10),
                contrato_codigo: item.contrato_codigo,
                info_tipo: item.info_tipo,
                info_fecha_pago: item.info_fecha_pago,
                info_costo_alquiler: parseFloat(item.info_costo_alquiler),
                info_exoneracion: parseFloat(item.info_exoneracion),
                total_cancelar: parseFloat(item.total_cancelar),
                total_recibido: parseFloat(item.total_recibido),
                total_saldo: parseFloat(item.total_saldo),
                isPaid: item.isPaid
            }))
        }
        
    }
    
    const getBodyForExpenseExemptions = ({user, FormRequestGlobal, isForUpdate}) => {
           
        const currentDate = getCurrentDate()

        return {
            idgestion : FormRequestGlobal.formState.idgestion,
            idgestiontipo : FormRequestGlobal.formState.idgestiontipo,
            idcontrato : FormRequestGlobal.formState.idcontrato,
            aprobacion_check : FormRequestGlobal.formState.aprobacion_check, 
            aprobacion_usuario: user.username, 
            aprobacion_fecha: currentDate,
            expenseExemptionDetails: FormRequestGlobal.formState.expenseExemptionDetails.map((item) => ({
                idexpense: parseInt(item.idexpense, 10),
                idcontrato: parseInt(item.idcontrato, 10),
                contrato_codigo: item.contrato_codigo,
                info_tipo: item.info_tipo,
                info_fecha_pago: item.info_fecha_pago,
                info_costo: parseFloat(item.info_costo),
                info_exoneracion: parseFloat(item.info_exoneracion),
                total_cancelar: parseFloat(item.total_cancelar),
                total_recibido: parseFloat(item.total_recibido),
                total_saldo: parseFloat(item.total_saldo),
                isPaid: item.isPaid
            }))
        }
        
    }


    
    return Object.freeze({
        identifySelectedRequestType,
        getCurrentDate,
        getGeneralBody,
        getBodyForDateChange,
        getBodyForPaymentExemptions,
        getBodyForExpenseExemptions
    })
}